/* eslint-disable react/forbid-prop-types */
import PropTypes from "prop-types";
import Desktop from "./desktop";
import Mobile from "./mobile";

const PDPPopup = ({
	isMobile,
	text,
	color,
	show,
	onHide,
	withOk,
	closable,
}) => (
	<>
		{!isMobile
			? (
				<Desktop
					onHide={onHide}
					show={show}
					text={text}
					color={color}
					withOk={withOk}
					closable={closable}
				/>
			)
			: (
				<Mobile
					onHide={onHide}
					show={show}
					text={text}
					color={color}
					withOk={withOk}
					closable={closable}
				/>
			)}
	</>
);

PDPPopup.propTypes = {
	isMobile: PropTypes.bool,
	text: PropTypes.string,
	color: PropTypes.string,
	show: PropTypes.bool,
	onHide: PropTypes.func,
	withOk: PropTypes.bool,
	closable: PropTypes.bool,
};

PDPPopup.defaultProps = {
	isMobile: false,
	text: "",
	show: false,
	color: "#323942",
	onHide: (() => false),
	withOk: true,
	closable: true,
};

export default PDPPopup;
